import { auditPassEnterpriseApi } from '@eastcoal/api/auth/audit/auditPassEnterprise'
import { queryAuditEnterpriseDetailByMemberIdApi } from '@eastcoal/api/auth/audit/queryAuditEnterpriseDetailByMemberId'
import { AuditEnterpriseEntity } from '@eastcoal/api/auth/interface'

import { PageContainer } from '@eastcoal/common/components/Layout/PageContainer'

import { CrudForm } from '@eastcoal/formily/components/CrudForm'

import { useNavigate } from '@eastcoal/router/exports/react-router'

import {
  AuditEnterpriseFormExposedProps,
  AuditEnterpriseFormProps
} from './interface'
import { auditEnterpriseFormSchema } from './schema'

const formatterDetail = (detail: AuditEnterpriseEntity) => {
  return {
    ...detail,
    certifications: detail.certifications?.map(
      item =>
        ({
          ...item,
          timeType: `${item.timeType}`
        }) as AuditEnterpriseEntity
    )
  }
}

const updateApi: AuditEnterpriseFormProps['updateApi'] = values =>
  auditPassEnterpriseApi(values)

const readApi: AuditEnterpriseFormProps['readApi'] = ({ memberId }) => {
  return {
    api: async () => {
      const data = await queryAuditEnterpriseDetailByMemberIdApi({ memberId })
      return formatterDetail(data)
    },
    read: !!memberId,
    refreshDeps: [memberId]
  }
}

export const AuditEnterpriseForm = ({
  mode,
  actions
}: AuditEnterpriseFormExposedProps) => {
  const navigate = useNavigate()
  console.log('actions', actions)
  return (
    <PageContainer>
      <CrudForm
        actions={actions}
        grid={false}
        mode={mode}
        name='memberAuditEnterpriseForm'
        readApi={readApi}
        schema={auditEnterpriseFormSchema}
        updateApi={updateApi}
        layout={{
          wrapperWidth: 400
        }}
        styles={{
          body: {
            width: 1000,
            margin: '0 auto',
            padding: 0
          }
        }}
        onSuccess={() => navigate('/audit/success')}
      />
    </PageContainer>
  )
}
